<template>
    <!-- Główny kontener, zawierający sekcję filtrów i formularz -->
    <div class="content">
      <div class="d-flex filters">
        <!-- Przypisujemy dynamiczny key, żeby łatwo resetować cały filtr -->
        <FilterCalibrationComponent />
  
        <form @submit.prevent="saveData" class="mt-3 d-flex align-items-center">
          <label for="calibration-datetime" class="me-2">Wybierz datę i godzinę:</label>
          <input
            id="calibration-datetime"
            type="datetime-local"
            v-model="selectedDateTime"
            required
            class="form-control me-2"
          />
          <button type="submit" class="btn btn-primary">
            Zapisz i zaloguj
          </button>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import moment from "moment";
  import FilterCalibrationComponent from "./FilterCalibrationComponent";
  import CalibrationsService from "@/services/CalibrationsService";
  
  moment.locale("pl");
  
  export default {
    name: "CalibrationAddComponent",
    components: { FilterCalibrationComponent },
    data() {
      return {
        // tu trzymamy wybór daty
        selectedDateTime: ""
      };
    },
    methods: {
      async saveData() {
        if (!this.selectedDateTime) return;
        // console.log("Wybrana data i godzina:", this.selectedDateTime);
  
        // moment.utc czy toISOString? Zależy jak API oczekuje strefy
        const timeISO = moment(this.selectedDateTime).toISOString(true);
  
        try {
          await CalibrationsService.addNewCalibrationTime(timeISO);
          // console.log("Odpowiedź z serwera:", response);
  
          // 1) wyczyść formularz:
          this.selectedDateTime = "";
  
          // 2) zresetuj też cały filtr (przeładowanie komponentu via key)
        //   this.filterKey += 1;
  
        } catch (err) {
          console.error("Błąd podczas zapisu:", err);
          // TODO: obsłuż błąd (np. toast, alert)
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .filters {
    gap: 1rem;
  }
  /* Styl głównego kontenera */
  .content {
    width: 100%;
    min-height: 270px;
    margin-bottom: 20px;
  }
  /* Granice sekcji filtrów */
  .filters {
    border-top: 1px solid #bbbbbb;
    border-bottom: 1px solid #bbbbbb;
  }
  /* Styl sekcji wyników */
  .results {
    width: 100%;
    padding: 1rem;
    background: #f9f9f9;
    border-radius: 4px;
    font-family: monospace;
    font-size: 0.9rem;
  }
  
  /* Kontener przycisków nawigacyjnych */
  .actions {
    background-color: white;
    min-height: 43px;
  }
  /* Wspólny styl przycisków */
  .actions button {
    border: 0;
    font-size: 19px;
    font-weight: bold;
    background: none;
  }
  /* Styl przycisku Zastosuj, z ikonką po prawej */
  .actions .btn-next {
    position: relative;
    padding: 8px 40px 8px 8px;
    color: #58585a;
  }
  .actions .btn-next::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    width: 30px;
    height: 20px;
    background: url("../assets/icons/dalej.png") no-repeat center;
  }
  .actions .btn-next:hover::after {
    background-image: url("../assets/icons/dalej_over.png");
  }
  /* Styl przycisku Cofnij */
  .actions .btn-prev {
    margin-left: 30px;
    padding: 0 0 0 40px;
    position: relative;
    color: #58585a;
  }
  .actions .btn-prev:before {
    content: "";
    position: absolute;
    left: 0;
    top: 11px;
    width: 30px;
    height: 20px;
    background: url("../assets/icons/powrot.png") no-repeat left top;
  }
  .actions .btn-prev:hover:before {
    background: url("../assets/icons/powrot_over.png") no-repeat left top;
  }
  /* Podświetlenie wiersza, gdy dewiacja > 7 */
  .red td {
    background-color: #f8d7da !important;
  }
  </style>